import { useState } from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import AddCircle from "@mui/icons-material/AddCircle";

import NewBlankCaseDialog from "components/CaseManagement/CaseForms/NewBlankCaseDialog";

export function AddCaseButton(props) {
  const [createCaseDialogVisible, setCreateCaseDialogVisible] = useState(false);

  const showCreateCaseDialog = () => setCreateCaseDialogVisible(true);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        data-qa={props["data-qa"]}
        onClick={showCreateCaseDialog}
        startIcon={<AddCircle />}
        sx={{ whiteSpace: "nowrap", px: 3 }}
      >
        Add New Case
      </Button>
      {createCaseDialogVisible ? (
        <NewBlankCaseDialog
          getUrlParams={props.getUrlParams}
          open={createCaseDialogVisible}
          setOpen={setCreateCaseDialogVisible}
          downDerateTrackerSource={props.downDerateTrackerSource}
        />
      ) : null}
    </>
  );
}

AddCaseButton.propTypes = {
  "data-qa": PropTypes.string,
  getUrlParams: PropTypes.func,
  downDerateTrackerSource: PropTypes.bool
};
